import type { MarkerRepository } from '../../application/MarkerRepository'
import { fieldMarkersFixtures, markersFixtures, markersHistoryFixtures } from './markersFixtures'

export function createFixtureMarkerRepository(): MarkerRepository {
  const records = [...markersFixtures]
  const historyRecords = [...markersHistoryFixtures]
  return {
    list() {
      return Promise.resolve(records.filter((task) => task.status === 'PENDING'))
    },
    listField() {
      return Promise.resolve([...fieldMarkersFixtures])
    },
    history() {
      return Promise.resolve(historyRecords)
    },
    complete() {
      return Promise.reject(new Error('MARKER_COMPLETE_SUPABASE_REQUIRED'))
    },
    reportFailure() {
      return Promise.reject(new Error('MARKER_FAILURE_SUPABASE_REQUIRED'))
    },
  }
}
